import { Typography } from '@mui/material'
import './footer.scss';

export const MuiFooter = () => {
    return (
        <footer style={{ position: "fixed", bottom: 0, textAlign: "center", width: "100%" }} className='footer'>
            <Typography className="title-footer">
                <a href="https://fitpal.co/terminos-aliados" target="blank">Términos y Condiciones</a>
            </Typography>
            <Typography className="title-footer">
                Diseño y desarrollo por Fitpal Colombia <span>© 2021 Fitpal sas</span>
            </Typography>
        </footer>
    )
}